export const slides = [
  {
    src: '/global-opportunities-section.png',
    alt: 'Study abroad planning support by Vedanskrix',
    title: 'Study abroad planning with clearer steps and stronger preparation',
    description:
      'We help students shortlist countries, improve applications, and prepare documents with less confusion and more confidence.',
  },
  {
    src: '/global-opportunities-section.png',
    alt: 'Visa support by Vedanskrix Global Opportunities',
    title: 'Visa support that keeps documents, interviews, and timing under control',
    description:
      'From checklist review to interview preparation, Vedanskrix helps applicants move through visa stages more smoothly.',
  },
  {
    src: '/global-opportunities-section.png',
    alt: 'International opportunity planning by Vedanskrix',
    title: 'Global opportunities for study, work, and long-term international growth',
    description:
      'We support candidates and families with practical planning for destinations, pathways, and next-step clarity.',
  },
];

export const spotlightCards = [
  {
    title: 'Study Abroad Guidance',
    text: 'University shortlisting, admission support, SOP review, and document planning for serious student applicants.',
  },
  {
    title: 'Work and PR Pathways',
    text: 'Practical support for skilled migration, work visa strategy, and profile alignment for long-term growth.',
  },
  {
    title: 'Visit and Business Travel',
    text: 'Clear checklists, application planning, and confidence-building support for visitor and business visa cases.',
  },
];

export const destinations = [
  {
    country: 'UK',
    focus: 'Student visa, graduate route, and education planning',
    detail:
      'A strong option for students looking for globally recognized education, shorter program structures, and smoother academic planning.',
  },
  {
    country: 'USA',
    focus: 'University pathways, profile strength, and admission planning',
    detail:
      'Useful for candidates aiming for broad academic choices, high-value profile building, and long-term international exposure.',
  },
  {
    country: 'NL',
    focus: 'Modern education routes and practical application support',
    detail:
      'Helpful for students exploring structured European education systems, country comparisons, and practical shortlist planning.',
  },
  {
    country: 'Canada',
    focus: 'Study permits, PGWP pathways, and dependent options',
    detail:
      'A good fit for students and skilled professionals who want long-term planning support, transparent documentation, and post-study clarity.',
  },
  {
    country: 'AUS',
    focus: 'Admissions guidance, visa prep, and documentation quality',
    detail:
      'Popular for education planning, profile-focused guidance, and application preparation that reduces avoidable filing mistakes.',
  },
];

export const serviceTracks = [
  {
    title: 'Profile assessment and goal mapping',
    text: 'We begin by understanding your academic record, experience, budget, timeline, and end goal before suggesting the right direction.',
  },
  {
    title: 'Country and pathway selection support',
    text: 'We help compare country options, study paths, work routes, and realistic opportunity windows based on your current profile.',
  },
  {
    title: 'Documentation checklist and review',
    text: 'Applications move better when the paperwork is organized. We help make documents cleaner, clearer, and submission-ready.',
  },
  {
    title: 'SOP, resume, and interview preparation',
    text: 'Communication quality matters. We support stronger SOP structure, profile presentation, and interview confidence.',
  },
  {
    title: 'Application submission guidance',
    text: 'From sequencing to final review, we reduce confusion so submissions happen with more confidence and fewer avoidable gaps.',
  },
  {
    title: 'Pre-departure planning and next-step support',
    text: 'We stay useful beyond approvals by helping you think through the next phase, not just the initial application.',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Discover the right route',
    text: 'We start with your budget, profile, goals, and timeline so the plan fits your real situation.',
  },
  {
    step: '02',
    title: 'Build a stronger application',
    text: 'We organize documents, sharpen communication, and reduce avoidable mistakes before submission.',
  },
  {
    step: '03',
    title: 'Move forward with confidence',
    text: 'From visa filing to interview prep, we keep the journey structured, calm, and action-oriented.',
  },
  {
    step: '04',
    title: 'Track the final stage carefully',
    text: 'We help you stay attentive during interview, review, and decision stages so momentum is not lost late in the process.',
  },
];

export const successReasons = [
  {
    title: 'Clarity before action',
    text: 'We do not rush people into steps they do not understand. Good decisions start with clear structure.',
  },
  {
    title: 'Profile-led guidance',
    text: 'Suggestions are aligned to the candidate, not copied from generic templates or random advice.',
  },
  {
    title: 'Communication quality',
    text: 'Better SOPs, clearer document flow, and stronger presentation improve the full rhythm of the application journey.',
  },
  {
    title: 'Human support throughout',
    text: 'Families and applicants value having a reliable guide who can simplify moving parts and reduce stress.',
  },
];

export const metrics = [
  { value: '1:1', label: 'Guidance tailored to each profile' },
  { value: '360', label: 'Support across admission, visa, and planning' },
  { value: 'Fast', label: 'Clear next steps after each consultation' },
];

export const happyCustomers = [
  {
    name: 'Riya S.',
    role: 'Student Applicant',
    text: 'The process felt much easier after Vedanskrix helped with shortlist clarity, SOP direction, and document preparation.',
  },
  {
    name: 'Harsh P.',
    role: 'Work Abroad Candidate',
    text: 'I liked that the guidance was practical and profile-based. It never felt like generic advice copied from somewhere else.',
  },
  {
    name: 'Family Consultation',
    role: 'Parents and Student',
    text: 'We got better clarity on country options, visa steps, and what to prepare first. That removed a lot of stress.',
  },
];
